import { green } from "@mui/material/colors";
import React from "react";
import { LetterIcon } from "./LetterIcon";

export const ForehandIcon = () => {
  return <LetterIcon color={green[500]} title="Forehand" />;
};
